module.exports = __webpack_public_path__ + "static/media/everyday_digital_full_crop.13519a45.png";